import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Chip,
  alpha,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { motion } from 'framer-motion';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PublicIcon from '@mui/icons-material/Public';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTenantConfig } from '../hooks/useTenant';

export default function ProjectDonationFlow() {
  const {tenantName} = useTenantConfig();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: { xs: 10, md: 14 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">

        {/* BAŞLIK */}
        <Box textAlign="center" mb={{ xs: 6, md: 10 }}>
          <Chip
            label="PROJE AKIŞI"
            size="small"
            sx={{
              mb: 2,
              backgroundColor: alpha('#2563eb', 0.12),
              color: '#2563eb',
              fontWeight: 700,
              fontSize: '0.75rem',
              letterSpacing: '0.8px',
              height: 32,
              px: 2,
              borderRadius: 2,
            }}
          />

          <Typography
            variant="h3" fontWeight={700} mb={2} color="#0f172a"
          >
            Proje – Bağış – Web Akışı
            <br />
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{ color: 'text.secondary', fontSize: '1.1rem' }}
          >
            {tenantName}'te bağış süreçleri proje ve bağış modülü üzerinden yönetilir.
            <br/>
            Tüm finansal ve içerik akışı tek yapı içinde ilerler.
          </Typography>
        </Box>

        {/* AKIŞ */}
        <Grid container spacing={3} alignItems="center">

          {/* PROJE */}
          <Grid item xs={12} md={3}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <FlowCard
                icon={<AccountTreeIcon />}
                title="Proje Oluşturulur"
                desc="Amaç, hedef bütçe ve süre belirlenir. Proje kategorisi seçilir."
                color="#2563eb"
              />
            </motion.div>
          </Grid>

          {/* OK */}
          <Arrow isMobile={isMobile} />

          {/* BAĞIŞ */}
          <Grid item xs={12} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <FlowCard
                icon={<VolunteerActivismIcon />}
                title="Bağışlar Projeye Bağlanır"
                desc="Yapılan bağışlar otomatik olarak ilgili projeye kaydedilir."
                color="#16a34a"
              />
            </motion.div>
          </Grid>

          {/* OK */}
          <Arrow isMobile={isMobile} />

          {/* WEB */}
          <Grid item xs={12} md={3}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <FlowCard
                icon={<PublicIcon />}
                title="Web Sitesinde Yayınlanır"
                desc="Projeler ve bağış durumu web sitesi ve widget'larda gösterilir."
                color="#f97316"
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

/* OK BİLEŞENİ */
function Arrow({ isMobile }) {
  return (
    <Grid item xs={12} md={1} sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <ArrowForwardIcon
        sx={{
          fontSize: isMobile ? 28 : 36,
          color: '#cbd5e1',
          transform: isMobile ? 'rotate(90deg)' : 'none',
          transition: 'all 0.3s ease'
        }}
      />
    </Grid>
  );
}

/* KART */
function FlowCard({ icon, title, desc, color }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        height: '100%',
        minHeight: 240,
        borderRadius: 3,
        border: '2px solid #e5e7eb',
        textAlign: 'center',
        transition: 'all 0.4s ease',
        '&:hover': {
          borderColor: color,
          boxShadow: `0 12px 30px ${alpha(color, 0.15)}`,
          transform: 'translateY(-4px)',
        }
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          mx: 'auto',
          mb: 3,
          borderRadius: '50%',
          background: `linear-gradient(135deg, ${alpha(color, 0.2)} 0%, ${alpha(color, 0.1)} 100%)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color,
          fontSize: 32,
          border: `2px solid ${alpha(color, 0.3)}`,
        }}
      >
        {icon}
      </Box>

      <Typography
        fontWeight={700}
        mb={2}
        sx={{
          fontSize: '1.15rem',
          color: '#0f172a',
          lineHeight: 1.3
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: '#64748b',
          fontSize: '0.95rem',
          lineHeight: 1.6,
          fontWeight: 500
        }}
      >
        {desc}
      </Typography>
    </Paper>
  );
}
